import { FC, ReactNode } from 'react';

import { Text, TextProps } from '@mantine/core';

import cx from './Page.module.scss';

const Description: FC<TextProps & { children?: ReactNode }> = ({ children, ...props }) => (
    <Text {...props} className={cx.description}>
        {children}
    </Text>
);

export { Description };
